/**
 * Formats the given message as markdown code (useful, for example, with the `InlineMarkdownCode` component).
 */
export function formatTextAsMarkdown(text: string): string {
  return text
    .split(" ")
    .map((str) => str.replace(/'([^']+)'/g, "`$1`"))
    .join(" ");
}
